/** Platform and integrations screens moved onto i18n (Brief 12). */
export const uzB12Platform2 = {
  "b12plat.egasi": "Egasi:",
  "b12plat.oneTimeLink": "Parol o'rnatish havolasi bir martalik, uni egasiga o'zingiz bering. Bu oynadan keyin qayta ko'rsatilmaydi.",
  "b12plat.kirmagan": "Kirmagan",
  "b12plat.paketsiz": "Paketsiz",
  "b12plat.umumiy-yonalishlar-royxati-har-b": "Umumiy yo'nalishlar ro'yxati: har bir agentlik qidiruvi va hisobotlari shu ro'yxatga tayanadi. Yo'nalishni o'chirib bo'lmaydi; uni faolsizlantiring. Agentlik o'z yo'nalishini bu ro'yxatga qo'sha oladi, lekin uni tahrirlay olmaydi.",
  "b12plat.har-bir-agentlik-mehmonxona-maso": "Har bir agentlik mehmonxona masofasini shu ro'yxatga nisbatan o'lchaydi. Aeroportni o'chirib bo'lmaydi; uni faolsizlantiring. Koordinatalar to'liq bo'lsa, to'g'ri masofa hisoblanadi.",
  "b12plat.kapitan-ulay-oladigan-taminotchi": "Kapitan ulay oladigan ta'minotchilar. Ro'yxat kod bilan belgilanadi; uni shu yerda o'zgartirib bo'lmaydi. Agentlik hisoblari «Provayderlar» ekranida ulanadi.",
  "b12plat.mijozga-yuboriladigan-xabarlarni": "Mijozga yuboriladigan xabarlarning standart matnlari. Matn kodda; bu yerda har bir shablon qaysi o'zgaruvchilarni talab qilishi ko'rinadi.",
  "b12plat.umumiy-mehmonxona-katalogi-mehmo": "Umumiy mehmonxona katalogi. Mehmonxonalar provayder nomlarini moslashtirish orqali yoziladi; qo'lda kiritilmaydi.",
  "b12plat.parol-saqlangandan-keyin-korsati": "Parol saqlangandan keyin ko'rsatilmaydi. Hisob keyingi qidiruvda qayta tekshiriladi.",
  "b12plat.aeroportni-saqlab-bolmadi-iata-k": "Aeroportni saqlab bo'lmadi. IATA kodi uch harfli va ro'yxatda yo'q bo'lishi kerak.",
  "b12plat.support-agentlik-malumotini-ozga": "Support agentlik ma'lumotini o'zgartira oladi. Har bir harakat jurnalga yoziladi.",
  "b12plat.yonalishni-saqlab-bolmadi-nomi-v": "Yo'nalishni saqlab bo'lmadi. Nomi va turi to'ldirilgan bo'lishi kerak.",
  "b12plat.davr-bugundan-boshlanadi-va-pake": "Davr bugundan boshlanadi va paket kreditlari shu davr uchun beriladi.",
  "b12plat.barcha-agentliklar-boyicha-yozuv": "Barcha agentliklar bo'yicha yozuvlar, eng yangisi birinchi.",
  "b12plat.faqat-korish-har-bir-harakat-jur": "Faqat ko'rish. Har bir harakat jurnalga yoziladi.",
  "b12plat.yangi-qiymat-ozgarmasa-bosh-qold": "Yangi qiymat (o'zgarmasa bo'sh qoldiring)",
  "b12plat.bu-bolimni-faqat-agentlik-egasi": "Bu bo'limni faqat agentlik egasi ko'radi.",
  "b12plat.sorov-bajarilmadi-qayta-urinib-k": "So'rov bajarilmadi. Qayta urinib ko'ring.",
  "b12plat.faol-yangi-agentliklar-uchun-tan": "Faol (yangi agentliklar uchun tanlanadi)",
  "b12plat.sabab-majburiy-jurnalga-yoziladi": "Sabab (majburiy; jurnalga yoziladi)",
  "b12plat.filiallar-har-biri-yangi-qatorda": "Filiallar (har biri yangi qatorda)",
  "b12plat.support-rejimini-boshlab-bolmadi": "Support rejimini boshlab bo'lmadi.",
  "b12plat.hali-muvaffaqiyatli-tekshirilmag": "Hali muvaffaqiyatli tekshirilmagan",
  "b12plat.holatni-ozgartirib-bolmadi": "Holatni o'zgartirib bo'lmadi.",
  "b12plat.ozgarishni-saqlab-bolmadi": "O'zgarishni saqlab bo'lmadi.",
  "b12plat.boshqa-nomlari-vergul-bilan": "Boshqa nomlari, vergul bilan",
  "b12plat.qoshimcha-kredit-narxi-uzs": "Qo'shimcha kredit narxi, UZS",
  "b12plat.agentlikni-yaratib-bolmadi": "Agentlikni yaratib bo'lmadi.",
  "b12plat.tur-provayderlari-ulanmagan": "Tur provayderlari ulanmagan.",
  "b12plat.tolov-boyicha-toxtatilgan": "To'lov bo'yicha to'xtatilgan",
  "b12plat.xodimlar-soni-0-cheksiz": "Xodimlar soni (0 — cheksiz)",
  "b12plat.standart-xabar-shablonlari": "Standart xabar shablonlari",
  "b12plat.tarifni-belgilab-bolmadi": "Tarifni belgilab bo'lmadi.",
  "b12plat.support-sessiyasi-yopildi": "Support sessiyasi yopildi.",
  "b12plat.support-rejimini-boshlash": "Support rejimini boshlash",
  "b12plat.sessiyani-yopib-bolmadi": "Sessiyani yopib bo'lmadi.",
  "b12plat.parol-ornatish-havolasi": "Parol o'rnatish havolasi",
  "b12plat.tarifni-saqlab-bolmadi": "Tarifni saqlab bo'lmadi.",
  "b12plat.ozgartirish-ruxsati-bor": "O'zgartirish ruxsati bor",
  "b12plat.administrator-toxtatgan": "Administrator to'xtatgan",
  "b12plat.agentlikka-aylantirildi": "Agentlikka aylantirildi",
  "b12plat.qidiruv-elon-qilingan": "Qidiruv e'lon qilingan",
  "b12plat.ai-kreditlari-oyiga": "AI kreditlari (oyiga)",
  "b12plat.integratsiyalar-yoq": "Integratsiyalar yo'q.",
  "b12plat.yonalish-qoshildi": "Yo'nalish qo'shildi.",
  "b12plat.holat-ozgartirildi": "Holat o'zgartirildi.",
  "b12plat.holatni-ozgartirish": "Holatni o'zgartirish",
  "b12plat.ozgartirish-ruxsati": "O'zgartirish ruxsati",
  "b12plat.ulanishni-tekshirish": "Ulanishni tekshirish",
  "b12plat.umumiy-yonalishlar": "Umumiy yo'nalishlar",
  "b12plat.mehmonxonalar-yoq": "Mehmonxonalar yo'q.",
  "b12plat.agentlik-yaratildi": "Agentlik yaratildi.",
  "b12plat.tasdiqlab-bolmadi": "Tasdiqlab bo'lmadi.",
  "b12plat.aeroport-qoshildi": "Aeroport qo'shildi.",
  "b12plat.yonalishlar-yoq": "Yo'nalishlar yo'q.",
  "b12plat.provayderlar-yoq": "Provayderlar yo'q.",
  "b12plat.tarifni-tahrirlash": "Tarifni tahrirlash",
  "b12plat.kreditlar-berildi": "Kreditlar berildi.",
  "b12plat.sorov-rad-etildi": "So'rov rad etildi.",
  "b12plat.rad-etib-bolmadi": "Rad etib bo'lmadi.",
  "b12plat.faol-sessiya-yoq": "Faol sessiya yo'q.",
  "b12plat.kalit-kiritilmagan": "Kalit kiritilmagan",
  "b12plat.tarif-belgilandi": "Tarif belgilandi.",
  "b12plat.tarifni-belgilash": "Tarifni belgilash",
  "b12plat.kredit-sorovlari": "Kredit so'rovlari",
  "b12plat.tasdiq-kutilmoqda": "Tasdiq kutilmoqda",
  "b12plat.aeroportlar-yoq": "Aeroportlar yo'q.",
  "b12plat.agentlikka-kirish": "Agentlikka kirish",
  "b12plat.parolni-yangilash": "Parolni yangilash",
  "b12plat.tur-provayderlari": "Tur provayderlari",
  "b12plat.kirish-rad-etildi": "Kirish rad etildi",
  "b12plat.javob-tushunarsiz": "Javob tushunarsiz",
  "b12plat.mahsulot-paket": "Mahsulot (paket)",
  "b12plat.faolsizlantirish": "Faolsizlantirish",
  "b12plat.shablonlar-yoq": "Shablonlar yo'q.",
  "b12plat.egasining-emaili": "Egasining emaili",
  "b12plat.sabab-majburiy": "Sabab (majburiy)",
  "b12plat.filtrni-tozalash": "Filtrni tozalash",
  "b12plat.parol-yangilandi": "Parol yangilandi",
  "b12plat.parol-rad-etildi": "Parol rad etildi",
  "b12plat.tolov-tizimlari": "To'lov tizimlari",
  "b12plat.tarif-saqlandi": "Tarif saqlandi.",
  "b12plat.oylik-narx-uzs": "Oylik narx, UZS",
  "b12plat.sorovlar-yoq": "So'rovlar yo'q.",
  "b12plat.integratsiyalar": "Integratsiyalar",
  "b12plat.demo-belgilandi": "Demo belgilandi",
  "b12plat.faollashtirish": "Faollashtirish",
  "b12plat.ozgaruvchilar": "O'zgaruvchilar",
  "b12plat.egasining-ismi": "Egasining ismi",
  "b12plat.holat-boyicha": "Holat bo'yicha",
  "b12plat.yozuvlar-yoq": "Yozuvlar yo'q.",
  "b12plat.support-rejimi": "Support rejimi",
  "b12plat.tekshirilmagan": "Tekshirilmagan",
  "b12plat.mamlakat-kodi": "Mamlakat kodi",
  "b12plat.mehmonxonalar": "Mehmonxonalar",
  "b12plat.audit-jurnali": "Audit jurnali",
  "b12plat.koordinatalar": "Koordinatalar",
  "b12plat.qayta-urinish": "Qayta urinish",
  "b12plat.javob-bermadi": "Javob bermadi",
  "b12plat.yonalishlar": "Yo'nalishlar",
  "b12plat.nomi-lotin": "Nomi (lotin)",
  "b12plat.provayderlar": "Provayderlar",
  "b12plat.imkoniyatlar": "Imkoniyatlar",
  "b12plat.bekor-qilish": "Bekor qilish",
  "b12plat.tasdiqlangan": "Tasdiqlangan",
  "b12plat.faqat-oqish": "Faqat o'qish",
  "b12plat.tizim-holati": "Tizim holati",
  "b12plat.integratsiya": "Integratsiya",
  "b12plat.kiritilmagan": "Kiritilmagan",
  "b12plat.yangi-holat": "Yangi holat",
  "b12plat.yangi-tarif": "Yangi tarif",
  "b12plat.rad-etilgan": "Rad etilgan",
  "b12plat.aeroportlar": "Aeroportlar",
  "b12plat.yangi-parol": "Yangi parol",
  "b12plat.boglanildi": "Bog'lanildi",
  "b12plat.sozlanmagan": "Sozlanmagan",
  "b12plat.shablonlar": "Shablonlar",
  "b12plat.yuborilgan": "Yuborilgan",
  "b12plat.tasdiqlash": "Tasdiqlash",
  "b12plat.tahrirlash": "Tahrirlash",
  "b12plat.rad-etildi": "Rad etildi",
  "b12plat.ishlayapti": "Ishlayapti",
  "b12plat.faol-emas": "Faol emas",
  "b12plat.platforma": "Platforma",
  "b12plat.yonalish": "Yo'nalish",
  "b12plat.rad-etish": "Rad etish",
  "b12plat.iata-kodi": "IATA kodi",
  "b12plat.provayder": "Provayder",
  "b12plat.bolimlar": "Bo'limlar",
  "b12plat.mamlakat": "Mamlakat",
  "b12plat.qoshish": "Qo'shish",
  "b12plat.yaratish": "Yaratish",
  "b12plat.agentlik": "Agentlik",
  "b12plat.boshlash": "Boshlash",
  "b12plat.saqlandi": "Saqlandi",
  "b12plat.tafsilot": "Tafsilot",
  "b12plat.yopilgan": "Yopilgan",
  "b12plat.oldingi": "Oldingi",
  "b12plat.keyingi": "Keyingi",
  "b12plat.saqlash": "Saqlash",
  "b12plat.tanlang": "Tanlang",
  "b12plat.hammasi": "Hammasi",
  "b12plat.harakat": "Harakat",
  "b12plat.kenglik": "Kenglik",
  "b12plat.uzunlik": "Uzunlik",
  "b12plat.ulangan": "Ulangan",
  "b12plat.shahar": "Shahar",
  "b12plat.yulduz": "Yulduz",
  "b12plat.yopish": "Yopish",
  "b12plat.kredit": "Kredit",
  "b12plat.muddat": "Muddat",
  "b12plat.hudud": "Hudud",
  "b12plat.holat": "Holat",
  "b12plat.kalit": "Kalit",
  "b12plat.tarif": "Tarif",
  "b12plat.sabab": "Sabab",
  "b12plat.login": "Login",
  "b12plat.yangi": "Yangi",
  "b12plat.turi": "Turi",
  "b12plat.nomi": "Nomi",
  "b12plat.faol": "Faol",
  "b12plat.izoh": "Izoh",
  "b12plat.yoq": "Yo'q",
  "b12plat.vaqt": "Vaqt",
  "b12plat.amal": "Amal",
  "b12plat.xato": "Xato",
  "b12plat.kim": "Kim",
  "b12plat.ha": "Ha",
} as const;
